export default __webpack_public_path__ + "static/media/2.de10d174.jpg";